export const CustomBlocksNamespace = "Custom_Blocks";
export const OutputBlockName = "OutputBlock";
//# sourceMappingURL=constants.js.map